/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Dl_Verify_CtaInputs */

const en_fc_dl_verify_cta = /** @type {(inputs: Fc_Dl_Verify_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SHA256SUMS.txt`)
};

/**
* | output |
* | --- |
* | "SHA256SUMS.txt" |
*
* @param {Fc_Dl_Verify_CtaInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_dl_verify_cta = /** @type {((inputs?: Fc_Dl_Verify_CtaInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Dl_Verify_CtaInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_dl_verify_cta(inputs)
});
export { fc_dl_verify_cta as "fc.dl.verify.cta" }